import React from "react";
import { Collapse } from "react-bootstrap";

function Step1Email({
  currentStep,
  handleGoToStep,
  handleNextStep,
  email,
  setEmail,
  validationErrors,
  setValidationErrors,
}) {
  return (
    <div className="card rounded-0 border-0 checkoutCard mb-3">
      <div className="card-header border-0 d-flex justify-content-between">
        <h5
          className={`text-capitalize mb-0 fw-bold ${
            currentStep === 1 ? "" : "text-grey"
          } ${currentStep > 1 ? "text-primary-color" : ""}`}
        >
          1. Email
        </h5>
        {currentStep > 1 ? (
          <button
            className="border-0 bg-0 text-grey"
            onClick={() => handleGoToStep(1)}
          >
            Edit
          </button>
        ) : null}
      </div>
      <Collapse in={currentStep === 1}>
        <div>
          <div className="card-body">
            <input
              type="email"
              className={`form-control mb-3 paymentInputFields ${
                validationErrors.email ? "has-error" : ""
              }`}
              placeholder="Enter your email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setValidationErrors({
                  ...validationErrors,
                  email: "",
                });
              }}
            />
            <div className="d-flex justify-content-end">
              <button
                className="continuePaymentBtn w-100 bg-primary-color border-0 p-1 text-white"
                onClick={() => handleNextStep(2)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default Step1Email;
